import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { buildAbsoluteAPIUrl } from '../utils/urlUtils';
const portalId = PortalIdParser.get();
const SYNC_BRIDGE_URL = '/sync-bridge';
const GET_APPS_URL = `${SYNC_BRIDGE_URL}/v5/apps`;
const GET_APPS_ACCOUNTS_URL = `${SYNC_BRIDGE_URL}/v3/accounts`;
export const getDataSyncApps = () => {
  return http.get(buildAbsoluteAPIUrl({
    path: GET_APPS_URL,
    query: {
      portalId
    }
  }));
};
export const getDataSyncAppAccounts = appId => {
  return http.get(buildAbsoluteAPIUrl({
    path: GET_APPS_ACCOUNTS_URL,
    query: {
      portalId,
      appId
    }
  }));
};